import { ARTISAN_PROCESS_STEPS } from "@/lib/constants";

export default function ArtisanProcess() {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-[var(--perahan-ivory)] px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-5xl font-serif font-bold text-[var(--perahan-charcoal)] mb-6">
            The Making of Perahan
          </h1>
          <p className="text-lg text-[var(--perahan-gray)] max-w-4xl mx-auto leading-relaxed">
            Our process begins with hand-carved wooden blocks, dipped in natural dyes, then pressed onto fabric by skilled artisans. 
            Every motif is carefully aligned, every color chosen with purpose. Our block printers, cutters, and tailors uphold a 
            tradition passed down for generations — resulting in timeless clothing that speaks to culture, craft, and care.
          </p>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ARTISAN_PROCESS_STEPS.map((step) => (
              <div key={step.step} className="text-center fade-in">
                <div className="relative mb-6">
                  <img 
                    src={step.image}
                    alt={`Step ${step.step}: ${step.title}`}
                    className="rounded-lg shadow-lg w-full h-48 object-cover"
                    loading="lazy"
                  />
                  <div className="absolute -top-4 -left-4 w-8 h-8 bg-[var(--perahan-maroon)] text-white rounded-full flex items-center justify-center font-bold">
                    {step.step}
                  </div>
                </div>
                <h3 className="text-xl font-serif font-semibold text-[var(--perahan-charcoal)] mb-2">
                  {step.title}
                </h3>
                <p className="text-[var(--perahan-gray)]">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Craftsmanship Philosophy */}
      <section className="py-20 bg-white px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-serif font-bold text-[var(--perahan-charcoal)] mb-8">
            Philosophy of Craftsmanship
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-left">
              <h3 className="text-2xl font-serif font-semibold text-[var(--perahan-maroon)] mb-4">
                Slow Fashion Movement
              </h3>
              <p className="text-[var(--perahan-gray)] mb-6 leading-relaxed">
                In an era of fast fashion, we believe in taking time. Each garment requires days, sometimes weeks, 
                to complete. This isn't inefficiency—it's intentional craftsmanship that ensures every piece 
                will last for generations.
              </p>
              
              <h3 className="text-2xl font-serif font-semibold text-[var(--perahan-maroon)] mb-4">
                Cultural Sustainability
              </h3>
              <p className="text-[var(--perahan-gray)] leading-relaxed">
                By preserving traditional techniques and employing local artisans, we maintain a living connection 
                to our cultural heritage while providing sustainable livelihoods to craftspeople who might otherwise 
                see their skills forgotten.
              </p>
            </div>
            <div>
              <img 
                src="https://pixabay.com/get/g5f7e9c4a8c48a6c8f6f7b4a7e3b3a4a4e4b3f6c5a3b4f6e8c9d7f8a5b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6q7r8s9t0u1v2w3x4y5z6a7b8c9d0e1f2g3h4i5j6k7l8m9n0o1p2q3r4s5t6u7v8w9x0y1z2_1280.jpg"
                alt="Traditional craftsperson working with dedication"
                className="rounded-lg shadow-lg w-full h-auto"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[var(--perahan-ivory)] px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-serif font-bold text-[var(--perahan-charcoal)] mb-6">
            Experience the Artistry
          </h2>
          <p className="text-lg text-[var(--perahan-gray)] mb-8 max-w-2xl mx-auto">
            Visit our workshop to witness these time-honored techniques firsthand, or explore our collection 
            to own a piece of this living heritage.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => {
                const message = encodeURIComponent("Hi! I'd like to schedule a workshop visit to see the artisan process. When would be a good time?");
                window.open(`https://wa.me/923035074455?text=${message}`, '_blank');
              }}
              className="btn-primary"
            >
              Schedule Workshop Visit
            </button>
            <button 
              onClick={() => {
                window.location.href = '/collection';
              }}
              className="btn-terracotta"
            >
              Browse Collection
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
